import { isBoolean, isDigit, isNumber, isString, isStringLike, IAstNodeType } from '../utils/type';


export interface IArgumentType extends IAstNodeType {
    fqn?: string;
    ownerFqn: string;
    token?: any;
}

// 是否存在非数字类型
export function hasNotDigitArgs(args: IArgumentType[]) {
    return args.find(arg => !isDigit(arg, false));
}

// 是否存在Number类型
export function hasNumberArgs(args: IArgumentType[]) {
    return args.find(arg => isNumber(arg, false));
}


// 是否存在非布尔类型
export function hasNotBooleanArgs(args: IArgumentType[]) {
    return args.find(arg => !isBoolean(arg, false));
}



// 是否存在非类字符串类型
export function hasNotStringArgs(args: IArgumentType[]) {
    return args.find(arg => !isString(arg, false));
}


// 是否存在非类字符串类型
export function hasNotStringLikeArgs(args: IArgumentType[]) {
    return args.find(arg => !isStringLike(arg, false));
}
